import React, { PureComponent } from 'react';
import classnames from 'classnames';
const DIAMETER = 62;

const Circular = props => {
  const {
    prefixCls,
    className,
    size,
    percent,
    strokeWidth,
    loading,
    style
  } = props;
  const cls = classnames(className, prefixCls, {
    [`${prefixCls}--${size}`]: !!size,
    [`${prefixCls}--circular`]: loading
  });
  const half = DIAMETER / 2;
  const r = half - strokeWidth / 2;
  const round = 2 * Math.PI * r;
  const lineStyle = {
    strokeDasharray: `${round * percent / 100} ${round}`,
    strokeWidth
  };

  if (loading) {
    return React.createElement("span", {
      className: cls,
      style: style
    }, React.createElement("svg", {
      viewBox: `${DIAMETER / 2} ${DIAMETER / 2} ${DIAMETER} ${DIAMETER}`
    }, React.createElement("circle", {
      cx: DIAMETER,
      cy: DIAMETER,
      r: r,
      fill: "none",
      style: {
        strokeWidth
      }
    })));
  }

  return React.createElement("span", {
    className: cls,
    style: style
  }, React.createElement("svg", {
    viewBox: `0 0 ${DIAMETER} ${DIAMETER}`
  }, React.createElement("circle", {
    className: `${prefixCls}__path`,
    cx: half,
    cy: half,
    r: r,
    fill: "none",
    style: {
      strokeWidth
    }
  }), React.createElement("circle", {
    className: `${prefixCls}__line`,
    cx: half,
    cy: half,
    r: r,
    fill: "none",
    style: lineStyle
  })));
};

const Spinner = props => {
  const {
    prefixCls,
    className,
    size,
    style
  } = props;
  const cls = classnames(prefixCls, `${prefixCls}--spinner`, className, {
    [`${prefixCls}--${size}`]: !!size
  });
  const spinner = [];

  for (let i = 0; i < 12; i++) {
    spinner.push(React.createElement("div", {
      key: i
    }));
  }

  return React.createElement("div", {
    className: cls,
    style: style
  }, spinner);
};

export default class ActivityIndicator extends PureComponent {
  render() {
    const {
      type
    } = this.props;
    return type !== 'spinner' ? React.createElement(Circular, this.props) : React.createElement(Spinner, this.props);
  }

}
ActivityIndicator.defaultProps = {
  prefixCls: 'za-activity-indicator',
  strokeWidth: 5,
  percent: 20,
  type: 'circular',
  loading: true
};